import { Link } from 'react-router-dom';
import { getCategoryName } from '@/components/feature/Breadcrumb';

interface ArticleCardProps {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: number;
  image: string;
}

export default function ArticleCard({ id, title, excerpt, category, date, readTime, image }: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer">
      <Link to={`/article/${id}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            title={title}
          />
          <div className="absolute top-3 left-3">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500 text-background-50">
              {getCategoryName(category)}
            </span>
          </div>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
            {title}
          </h3>
          <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
            {excerpt}
          </p>
          <div className="mt-4 flex items-center gap-4 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {readTime} 分钟阅读
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}